import { render } from "./SubteamTile.vue?vue&type=template&id=54e0e43e"
import script from "./SubteamTile.vue?vue&type=script&lang=js"
export * from "./SubteamTile.vue?vue&type=script&lang=js"

import "./SubteamTile.vue?vue&type=style&index=0&id=54e0e43e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__